window.onload = function() {

    // Fix Banner envio gratis
    setTimeout(() => {
        
        let banEnvio = document.getElementById( 'fsb_container' );
        banEnvio.style.height = '41px';
    
    }, 900);

};